import { _ as _overArg } from './_overArg.mjs';

var overArg = _overArg;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

export { _getPrototype as _ };
